/**
 * @file AgentHistory.jsx
 * @description AgentHistory component for displaying and managing agent history.
 * @component AgentHistory
 * @exports AgentHistory - Main component for displaying and managing agent history.
 */

import React from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box } from "@mui/material";
import { SIZES, COLORS } from "../../../common/constants/commonConstants.js";
import { STATUS_STRINGS, HISTORY_TABLE_COLUMNS, HISTORY_TABLE_COLUMN_KEYS } from "../../../common/constants/agentModule/statusConstants.js";

const AgentHistory = ({ statusHistory }) => {
    return (
        statusHistory && (
            <>
                {Object.entries(statusHistory).map(([date, entries], index) => (
                    <Accordion key={index} defaultExpanded={index === 0}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>
                                {date}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TableContainer>
                                <Table size={SIZES.SMALL}>
                                    <TableHead>
                                        <TableRow>
                                            {HISTORY_TABLE_COLUMNS.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    sx={{
                                                        width:
                                                            column.id === HISTORY_TABLE_COLUMN_KEYS.STATUS ? 100 :
                                                            column.id === HISTORY_TABLE_COLUMN_KEYS.SKILLS ? 200 :
                                                            column.id === HISTORY_TABLE_COLUMN_KEYS.REASON ? 200 :
                                                            column.id === HISTORY_TABLE_COLUMN_KEYS.TIME ? 100 : 200,
                                                    }}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {entries.map((entry, i) => (
                                            <TableRow key={i}>
                                                <TableCell sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                    {entry.status}
                                                    <Box
                                                        sx={{
                                                            width: 12,
                                                            height: 12,
                                                            bgcolor: entry.status === STATUS_STRINGS.ONLINE ? COLORS.GREEN : COLORS.RED,
                                                            borderRadius: 25,
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    {entry.status === STATUS_STRINGS.ONLINE ? entry.skills.join(", ") : ""}
                                                </TableCell>
                                                <TableCell>
                                                    {entry.status === STATUS_STRINGS.OFFLINE ? entry.reason : ""}
                                                </TableCell>
                                                <TableCell>
                                                    {entry.time}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </AccordionDetails>
                    </Accordion>
                ))}
            </>
        )
    );
};

export default AgentHistory;